import { Component } from '@angular/core';
import { LogService } from './services/log.service';
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookiesInfoComponent } from './cookies-info/cookies-info.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = environment.debug ? 'qr-menu-dev' : 'look@menu';
  public debug = environment.debug;

  cookieMessage = 'Aby zapenić bezproblemowe świadczenie usługi, serwis look@menu korzysta z ciasteczek. Ciasteczka są również wykorzystywane do celów statystycznych \
  Dalsze korzystanie z serwisu oznacza, że zgadzasz się na ich użycie. Więcej informacji w <a href="/privacy-policy">Polityce prywatności</a>';

  constructor(
    public log: LogService,
    private cookieService: CookieService,
    private _snackBar: MatSnackBar
  ) {
      if(!this.cookieService.get('cookiesAccepted')){
        let snackbar = this._snackBar.openFromComponent(CookiesInfoComponent, {panelClass: ['cookies-info']});
        snackbar.afterDismissed().subscribe(() => this.cookieService.set('cookiesAccepted', 'OK',90));
      }
      // console.log(this.cookieService.get('cookiesAccepted'));
   }
}
